import { z } from "zod";

import { TINA_STAGES } from "@/lib/tina/constants";

export const promptOverrideRow = z.object({
  stage: z.enum(TINA_STAGES),
  prompt_version_id: z.string().uuid("Must be a valid UUID"),
});

export type PromptOverrideRow = z.infer<typeof promptOverrideRow>;

/**
 * Advanced run configuration. Sites/country/source/content are no longer part of
 * the form schema — they are managed by the faceted picker in `RunsCreate` and
 * submitted as the `sites` payload. This schema only validates the optional
 * tuning knobs that live in the "Advanced configuration" section.
 */
export const advancedConfigSchema = z.object({
  limit: z.number().int().positive().optional(),
  score_threshold: z.number().min(0).max(1).optional(),
  cost_cap_usd: z.number().nonnegative().optional(),
  dry_run: z.boolean().optional(),
  prompt_overrides: z.array(promptOverrideRow).optional(),
});

export type AdvancedConfigType = z.infer<typeof advancedConfigSchema>;
